import { getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useOptionImageStore } from './option-image';
import { resolvePackagePriceDisplay } from './package-price';
import { usePriceListStore } from './price-list';
export const useExteriorCustomStore = defineStore('exterior-custom', {
    state() {
        return {
            optionImgMap: {},
        };
    },
    getters: {
        /**
         * 外观定制配置项列表
         */
        exteriorList() {
            const featureListStore = useFeatureListStore();
            const optionImageStore = useOptionImageStore();
            const priceList = usePriceListStore();
            if (!featureListStore.data)
                return [];
            const exteriorCustomCodes = [
                CategoryCode.Exterior,
                SubCategoryCode.ExteriorCustom,
                FeatureType.ExteriorCustom,
            ];
            const exteriorCustomItem = getFeatureData(exteriorCustomCodes, featureListStore.data);
            return exteriorCustomItem?.option_list?.map((option) => {
                const item = featureListStore.data?.option_map[option];
                // 套装展示：命中 package_price_list 优先，否则保留 feature/list option 上的 package_price_desc（见 package-price.ts）
                const packagePriceDisplay = resolvePackagePriceDisplay({
                    optionCode: item?.code,
                    price: item?.price,
                    packagePriceList: featureListStore.effectivePackagePriceList,
                    optionPackagePriceDesc: item?.package_price_desc,
                });
                const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[option] || '';
                const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[option];
                if (!item?.code)
                    return {
                        ...item,
                        overViewImg: null,
                        discount_selected: false,
                        discount_tip: '',
                    };
                const discountData = {
                    discount_selected: !!priceDiscountTip,
                    discount_tip: priceDiscountTip || item?.discount_tip || '',
                    discount_tip_icon: priceDiscountTipIcon?.icon || item?.discount_tip_icon || '',
                    discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || item?.discount_tip_icon_ratio || 0,
                };
                const img = optionImageStore.exteriorCustomImgs?.[item.code]?.img_url_list?.[0] ??
                    this.optionImgMap[item?.code];
                this.optionImgMap[item?.code] = img;
                return {
                    ...item,
                    overViewImg: img,
                    ...packagePriceDisplay,
                    ...discountData,
                };
            });
        },
    },
});
